import { render, staticRenderFns } from "./huizong.vue?vue&type=template&id=4821dbfa&scoped=true"
import script from "./huizong.vue?vue&type=script&lang=js"
export * from "./huizong.vue?vue&type=script&lang=js"
import style0 from "./huizong.vue?vue&type=style&index=0&id=4821dbfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821dbfa",
  null
  
)

export default component.exports